<template>
  <div class="system-auth-container">
    <div class="table-prefix-box">
      <div class="btn-box">
        <el-button-group class="mr-10">
          <el-button @click="showDialog" size="mini"
                     type="primary" icon="el-icon-plus">新增
          </el-button>
          <el-button @click="clickEdit" size="mini"
                     type="primary" icon="el-icon-edit">编辑
          </el-button>
          <el-button @click="toggleRole" size="mini"
                     type="primary" icon="el-icon-set-up">切换角色
          </el-button>
          <el-button @click="del" size="mini"
                     type="primary" icon="el-icon-delete">删除
          </el-button>
        </el-button-group>
      </div>
      <div class="search-box mt-15"></div>
    </div>

    <div class="table mt-15">
      <el-table v-loading="tableLoading" border ref="table" :data="list" highlight-current-row
                @current-change="handleCurrentChange" style="width:100%">
        <el-table-column label="ID" width="100">
          <template slot-scope="scope"><span>12</span></template>
        </el-table-column>
        <el-table-column label="名称">
          <template slot-scope="scope"><span>zhangsanfeng@qq.com</span></template>
        </el-table-column>
        <el-table-column label="昵称">
          <template slot-scope="scope"><span>张三丰</span></template>
        </el-table-column>
        <el-table-column label="角色">
          <template slot-scope="scope"><span>普通用户</span></template>
        </el-table-column>
        <el-table-column label="状态">
          <template slot-scope="scope"><span>正常</span></template>
        </el-table-column>
      </el-table>
    </div>

    <div class="pagination pt-10 t-center">
      <el-pagination background layout="total,sizes,prev,pager,next,jumper"
                     :page-size="pagination.size" :page-sizes="[10,20,30,50]"
                     :current-page.sync="pagination.page"
                     :total="pagination.total" @size-change="changeSize"
                     @current-change="changeCurrent"></el-pagination>
    </div>

    <el-dialog title="切换角色" width="400px" :visible.sync="toggleRoleIsShow">
      <div class="add-box">
        <div class="o-hidden">
          <span class="span">选择角色</span>
          <el-select style="width:100%" size="mini" v-model="role" placeholder="请选择角色">
            <el-option
                v-for="item in [{value:'超级管理员',label:'超级管理员'},{value:'管理员',label:'管理员'},{value:'普通用户',label:'普通用户'}]"
                :key="item.value" :label="item.label" :value="item.value"></el-option>
          </el-select>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="toggleRoleIsShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submitRole">确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="添加" width="400px" :visible.sync="dialogShow">
      <div style="font-size:13px;">
        <el-input class="display-inline width100" v-model="obj.title" placeholder="用户名" size="mini">
        </el-input>
        <el-input class="display-inline width100 mt-15" v-model="obj.url" placeholder="昵称"
                  size="mini"></el-input>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click="dialogShow=false">取 消</el-button>
        <el-button size="mini" type="primary" @click="submit">确 定</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script type="text/ecmascript-6">
  import {tool} from "../../common/js/tool.js";
  import {Loading} from "element-ui";
  export default {
    data() {
      return {
        dialogShow: false,
        obj: {
          title: "",
          url: ""
        },
        list: [
          {sort: 1},
          {sort: 2},
          {sort: 3},
          {sort: 4},
          {sort: 6},
          {sort: 7},
          {sort: 9},
          {sort: 11},
          {sort: 13},
          {sort: 15},
          {sort: 17}
        ],
        tableLoading: false,
        authDialogShow: false,
        pagination: {
          page: 1,
          size: 10,
          total: 220
        },
        role: '超级管理员',
        toggleRoleIsShow: false
      };
    },

    computed: {},

    created() {
    },

    methods: {
      toggleRole(){
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.toggleRoleIsShow = true;
      },
      submitRole(){
        this.toggleRoleIsShow = false;
      },
      changeCurrent(val) {
        this.pagination.page = val;
        this.obj.page = val;
        this.getData(true);
      },
      getData(flag) {
        let obj = Object.assign({}, this.obj);
        obj.page = flag ? this.pagination.page : 1;
        this.pagination.page = flag ? this.pagination.page : 1;
        console.log(this.obj, this.pagination, obj);
        this.tableLoading = true;
        setTimeout(() => {
          this.tableLoading = false;
          this.pagination.total = 222;
          this.list = [
            {id: 1},
            {id: 2},
            {id: 3},
            {id: 4},
            {id: 5},
            {id: 6},
            {id: 7},
            {id: 8},
            {id: 9},
            {id: 10}
          ];
        }, 10);
      },

      changeSize(e) {
        this.pagination.size = e;
        this.obj.pageSize = e;
        this.getData();
      },
      handleCurrentChange(val) {
        this.currentRow = val;
        //console.log(val.id);
      },
      showDialog() {
        this.dialogShow = true;
      },
      handleCurrentChange(val) {
        this.currentRow = val;
      },
      submit() {
      },
      changeOrder(index) {
        console.log(index);
        let obj = {id: 12, sort: this.list[index].sort};
        alert(JSON.stringify(obj));
      },
      showAuthDialog() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.authDialogShow = true;
      },
      clickEdit() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
          return;
        }
        this.dialogShow = true;
      },
      del() {
        if (!this.currentRow) {
          tool.message("请在表格中选择数据", "error");
        } else {
          this.$confirm("确定要删除吗?", "提示", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          }).then(() => {
            this.$message({
              type: "success",
              duration: 1000,
              message: "操作成功!",
              onClose: () => {
                this.getData();
              }
            });
          });
        }
      }
    },

    components: {}
  };
</script>

<style lang="less" rel="stylesheet/less">
  .system-auth-container {
    width: 100%;
    height: auto;
    display: flex;
    padding: 15px;
    flex-direction: column;
    .auth-box {
      font-size: 13px;
      height: 400px;
      overflow-y: auto;
      border-top: 1px solid #dcdcdc;
      .item {
        height: 45px;
        line-height: 45px;
        padding: 0 20px;
        border-bottom: 1px solid #dcdcdc;
        span {
          height: 45px;
          line-height: 45px;
          display: block;
          float: left;
        }
        &.active {
          background: #f9f9f9;
        }
        .check {
          display: inline-block;
          width: 30px;
        }
        .color-409eff {
          color: #409eff;
        }
        .color-dcdcdc {
          color: #dcdcdc;
        }
      }
    }
  }
</style>
